// The template's formFields drive a fully dynamic shape (Record<string, unknown>) — there is
// no static FormInput type to define. This module owns the schema/default-values/payload
// shaping logic extracted out of the hook, mirroring the schemas/ extraction pattern used by
// static forms.

import { buildDefaultValues, buildFieldSchema } from '@klareospace/pharos-lib-front-utils';
import type { TemplateFormFieldDef } from '@klareospace/pharos-lib-types';
import { z } from 'zod/v4';

/** Field types that use the leave-blank-to-keep semantics on edit. */
export function isSecretField(type: TemplateFormFieldDef['type']): boolean {
  return type === 'password' || type === 'jwt';
}

export function buildEditSchema(fields: TemplateFormFieldDef[]): z.ZodObject<Record<string, z.ZodTypeAny>> {
  const shape: Record<string, z.ZodTypeAny> = {};
  for (const field of fields) {
    shape[field.key] = isSecretField(field.type) ? z.string().optional() : buildFieldSchema(field);
  }
  return z.object(shape);
}

export function buildEditDefaultValues(
  fields: TemplateFormFieldDef[],
  existingValues?: Record<string, unknown>,
): Record<string, unknown> {
  const base = buildDefaultValues(fields, existingValues);
  for (const field of fields) {
    if (isSecretField(field.type)) {
      base[field.key] = '';
    }
  }
  return base;
}

export function buildEditPayload(
  fields: TemplateFormFieldDef[],
  values: Record<string, unknown>,
): Record<string, unknown> {
  const payload: Record<string, unknown> = { ...values };
  for (const field of fields) {
    if (isSecretField(field.type) && (payload[field.key] === '' || payload[field.key] === undefined)) {
      delete payload[field.key];
    }
  }
  return payload;
}
